import ManageColumnsForm from './ManageColumnsForm.component';

export default ManageColumnsForm;
